import React, {useState} from "react";
const VolumeMetricsModal = ({summary}) => {
  
  function calculatePercentageDifference(todayVolume, lastDayVolume) {
    const difference = lastDayVolume - todayVolume ;
    const percentageDifference = (difference / lastDayVolume) * 100;
    const isPositive = percentageDifference >= 0;
    return (
      <p className={`m-0 ${isPositive ? "textgreen" : "textred"}`}>
        <i
          className={`fa-solid ${
            isPositive ? "fa-arrow-up" : "fa-arrow-down"
          }`}
        ></i>{" "}
        {parseFloat(Math.abs(percentageDifference)).toFixed(2)}%
      </p>
    );
  }
  return (
  <>
  <div className="text-center">
      <h2 className="mb-0 mt-5  w-100 good_times goldFont">UFO Avg. Trading Volume</h2>
  </div>
  <div className="row mt-4   ">
      <div className="col-sm-12 col-md-6 col-xl-4">
          <div className="subcontent subPad SRTOP">
              <div className="perVal fInter d-flex align-items-center flex-wrap">
                  <span>1 Week Average Trading Volume</span>
              </div>
              <div className="statBottom">
                  {calculatePercentageDifference(summary.day1, parseFloat(summary.week / 7))}
                  <div className="specialDollor mt-0  mb-0">
                      <span className="dollor">$</span>
                      <span className="val f28">{parseFloat(summary.week / 7).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
              </div>
          </div>
      </div>
      <div className="col-sm-12 col-md-6 col-xl-4">
          <div className="subcontent subPad SRTOP">
              <div className="perVal fInter d-flex align-items-center flex-wrap">
                  <span>1 Month Average Trading Volume</span>
              </div>
              <div className="statBottom">
                  {calculatePercentageDifference(summary.day1, parseFloat(summary.month / 30))}
                  <div className="specialDollor mt-0  mb-0">
                      <span className="dollor">$</span>
                      <span className="val f28">{parseFloat(summary.month / 30).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
              </div>
          </div>
      </div>
      <div className="col-sm-12 col-md-6 col-xl-4">
          <div className="subcontent subPad SRTOP">
              <div className="perVal fInter d-flex align-items-center flex-wrap">
                  <span>3 Months Average Trading Volume</span>
              </div>
              <div className="statBottom">
                  {calculatePercentageDifference(summary.day1, parseFloat(summary.days90 / 90))}
                  <div className="specialDollor mt-0  mb-0">
                      <span className="dollor">$</span>
                      <span className="val f28">{parseFloat(summary.days90 / 90).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
              </div>
          </div>
      </div>
      <div className="col-sm-12 col-md-6 col-xl-4">
          <div className="subcontent subPad SRTOP">
              <div className="perVal fInter d-flex align-items-center flex-wrap">
                  <span>6 Months Average Trading Volume</span>
              </div>
              <div className="statBottom">
                  {calculatePercentageDifference(summary.day1, parseFloat(summary.days180 / 180))}
                  <div className="specialDollor mt-0  mb-0">
                      <span className="dollor">$</span>
                      <span className="val f28">{parseFloat(summary.days180 / 180).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
              </div>
          </div>
      </div>
      <div className="col-sm-12 col-md-6 col-xl-4">
          <div className="subcontent subPad SRTOP">
              <div className="perVal fInter d-flex align-items-center flex-wrap">
                  <span>1 Year Average Trading Volume</span>
              </div>
              <div className="statBottom">
                  {calculatePercentageDifference(summary.day1, parseFloat(summary.yearly / 365))}
                  <div className="specialDollor mt-0  mb-0">
                      <span className="dollor">$</span>
                      <span className="val f28">{parseFloat(summary.yearly / 365).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
              </div>
          </div>
      </div>
  </div>
  </>
  );
};

export default VolumeMetricsModal;